import { Heading, WarningOutlined } from '@core/ui';
import { useTranslation } from 'react-i18next';

/**
 * Shown when the presenter switches away from an external encoder to a browser transport while that
 * encoder may still be publishing. Two publishers on one Vindral channel push each other off it and
 * both keep reconnecting, so the picture drops in and out until one of them stops. Naming that
 * symptom matters: it is what the presenter will actually see, and without it they blame us.
 */
export const ExternalIngestStillOpenWarning = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white bg-side-warning bg-20 bg-no-repeat rounded-lg flex flex-col items-start gap-1 mb-6 pl-6 md:pl-8 pr-4 md:pr-6 pt-4 pb-6">
            <WarningOutlined classNames="w-10 fill-warning mb-2" />
            <Heading variant="h3">{t('Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen')}</Heading>
            <p className="max-w-3xl">{t('Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen.Body')}</p>
        </div>
    );
};
